import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'event_name', label: 'Event name', type: 'text' },
    { key: 'event_date', label: 'Event date', type: 'text', placeholder: 'YYYY-MM-DD or a human string' },
    { key: 'location', label: 'Location', type: 'text' },
    { key: 'description', label: 'Description', type: 'textarea', rows: 3 },
    { key: 'cover_image', label: 'Cover image', type: 'upload-image', prefix: 'volunteer-albums' },
    { key: 'photos', label: 'Photos', type: 'images-list', prefix: 'volunteer-albums/photos' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'event_name', label: 'Event', primary: true },
    { key: 'event_date', label: 'Date' },
    { key: 'location', label: 'Location' },
    { key: 'photos', label: 'Photos', render: (r) => (r.photos || []).length },
];

const defaultItem = {
    event_name: '',
    event_date: '',
    location: '',
    description: '',
    cover_image: '',
    photos: [],
    order: 99,
};

export default function AdminVolunteerAlbumsPage() {
    return (
        <CrudManager
            resource="volunteer-albums"
            title="Volunteer Photo Albums"
            description="Event-wise volunteer photo albums (Photo Gallery public page)."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['event_name', 'location']}
        />
    );
}
